import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pickupPersonsApi, PickupPerson, PickupPersonInput } from '../api/pickupPersons';
import { QUERY_KEYS } from '../utils/constants';

export function usePickupPersons() {
  return useQuery({
    queryKey: [QUERY_KEYS.pickupPersons],
    queryFn: () => pickupPersonsApi.list(),
  });
}

export function useCreatePickupPerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, photoFormData }: { data: PickupPersonInput; photoFormData: FormData }) =>
      pickupPersonsApi.create(data, photoFormData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.pickupPersons] });
    },
  });
}

export function useUpdatePickupPerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<PickupPersonInput> & { is_active?: boolean } }) =>
      pickupPersonsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.pickupPersons] });
    },
  });
}

export function useDeletePickupPerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => pickupPersonsApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.pickupPersons] });
    },
  });
}

export function useUploadPickupPhoto() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, formData }: { id: string; formData: FormData }) =>
      pickupPersonsApi.uploadPhoto(id, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.pickupPersons] });
    },
  });
}